/**
 * Spend-versus-revenue measures for campaign reports.
 * Spend is what the campaign cost: SMS, discounts given and the value of loyalty rewards.
 */
import { formatCents } from './format';

/** Revenue per unit of spend, or null when nothing was spent. */
export function returnOnSpend(revenueCents: number, spendCents: number): number | null {
  return spendCents > 0 ? revenueCents / spendCents : null;
}

export function netReturnCents(revenueCents: number, spendCents: number): number {
  return revenueCents - spendCents;
}

/** Spend per attributed order, or null when there were no orders. */
export function costPerOrderCents(spendCents: number, orders: number): number | null {
  return orders > 0 ? Math.round(spendCents / orders) : null;
}

/** 4.23 → "4.2x"; 12.6 → "13x"; null → "—" */
export function formatReturn(value: number | null): string {
  if (value === null) return '—';
  return `${value >= 10 ? Math.round(value) : value.toFixed(1)}x`;
}

/** Net return with an explicit sign for losses: -1250 → "-$12.50". */
export function formatNet(cents: number): string {
  return cents < 0 ? `-${formatCents(-cents)}` : formatCents(cents);
}

/** SND-09 — one credit per SMS segment, priced per credit. Whole cents. */
export function smsCostCents(credits: number, pricePerCreditCents: number): number {
  return Math.round(credits * pricePerCreditCents);
}
